
export default function ArrowDropDownIcon() {
    return (
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0.335417L0 9.66458C0 9.9444 0.294357 10.1006 0.495312 9.92736L5.88431 5.26277C6.03856 5.12926 6.03856 4.87216 5.88431 4.73723L0.495312 0.0726437C0.294357 -0.100645 0 0.0555989 0 0.335417Z" fill="currentColor"/>
</svg>


    )
}